import { render, staticRenderFns } from "./AddCourseCat.vue?vue&type=template&id=24e364bc"
import script from "./AddCourseCat.vue?vue&type=script&lang=js"
export * from "./AddCourseCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports